import { Component, OnInit, Input, Output, EventEmitter, PLATFORM_ID, Inject } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { DataService } from "../services/data.service";
import { CookieService } from "ngx-cookie-service";
import { ToasterService } from "../services/toaster.service";
import { CommonModule, isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  imports: [CommonModule, RouterModule]
})
export class HeaderComponent implements OnInit {
  isUserLoggedIn: boolean = false;
  userDetail: any;
  isBrowser: boolean;

  @Output() shareUserDetail: EventEmitter<{
    userDetail: any;
  }> = new EventEmitter();
  @Input() headerNavMenu;
  @Input() url;

  constructor(
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private data: DataService,
    private toaster: ToasterService,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    this.auth.checkLogin();
    this.auth.isUserLoggedIn.subscribe((val) => {
      if (val) {
        this.isUserLoggedIn = val;
      }
    });
    if (this.isUserLoggedIn) {
      this.auth.getUserProfile().subscribe(
        (res: any) => {
          this.userDetail = res.data;
          this.shareUserDetail.emit({
            userDetail: this.userDetail,
          });
          if (this.isBrowser) {
            localStorage.setItem("uuid", res.data.uuid);
            sessionStorage.setItem("key", res.data.uuid);
            const dateNow = new Date();
            dateNow.setMonth(dateNow.getMonth() + 6);
            this.cookieService.set("_khuuid", res.data.uuid, { expires: dateNow, path: "/" });
          }
        },
        (err: any) => {
          this.userDetail = [];
          this.shareUserDetail.emit({
            userDetail: this.userDetail,
          });
        }
      );
    } else {
      this.userDetail = [];
      this.shareUserDetail.emit({
        userDetail: this.userDetail,
      });
    }
    if (this.isBrowser) {
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (document.getElementById("header") != null) {
          if (prevScrollpos > currentScrollPos) {
            document.getElementById("header").style.top = "0";
            // document.querySelector(".public-btn").classList.remove("drop");
          } else {
            document.getElementById("header").style.top = "-120px";
            // document.querySelector(".public-btn").classList.add("drop");
          }
        }
        prevScrollpos = currentScrollPos;
      };
    }
  }

  logout() {
    this.auth.logout().subscribe(
      (res: any) => {
        if (res.status === 200) {
          if (this.isBrowser) {
            localStorage.removeItem("access_token");
            // this.cookieService.deleteAll();
            this.auth.checkLogin();
            this.auth.isUserLoggedIn.subscribe((val) => {
              this.isUserLoggedIn = val;
            });
            if ('KudosHub' in window && typeof window.KudosHub === 'function') {
              window.KudosHub('shutdown', {
                appId: "",
                email: "",
                name: "",
                created_at: 0
              });
            } else {
              console.log('KudosHub is not defined on the window object.');
            }
          }
        }
      },
      (err: any) => {
        if (err.status === 401) {
          this.toaster.show(
            "error",
            "Check it out!",
            "There was a problem logging you out"
          );
        }
      }
    );
  }
}